<template>
    <div class="flex w-full p-2 gap-2">
        <UButton
            size="sm"
            color="neutral"
            variant="outline"
            @click="toggleInvoiceLists"
        >
            {{ showInvoiceLists ? 'Skjul kladder' : 'Vis kladder' }}
        </UButton>
        <UFieldGroup v-if="InvoiceDraftList.isEnabled && showInvoiceLists">
            <UButton
                size="sm"
                :variant="selectedTab === INVOICE_TAB.DRAFT ? 'solid' : 'outline'"
                :color="selectedTab === INVOICE_TAB.DRAFT ? 'primary' : 'neutral'"
                @click="selectedTab = INVOICE_TAB.DRAFT"
            >
                Kladder
            </UButton>
            <UButton
                size="sm"
                :variant="selectedTab === INVOICE_TAB.ALL ? 'solid' : 'outline'"
                :color="selectedTab === INVOICE_TAB.ALL ? 'primary' : 'neutral'"
                @click="selectedTab = INVOICE_TAB.ALL"
            >
                Alle fakturaer
            </UButton>
            <UButton
                size="sm"
                :variant="selectedTab === INVOICE_TAB.PAID ? 'solid' : 'outline'"
                :color="selectedTab === INVOICE_TAB.PAID ? 'primary' : 'neutral'"
                @click="selectedTab = INVOICE_TAB.PAID"
            >
                Betalte
            </UButton>
            <UButton
                size="sm"
                :variant="selectedTab === INVOICE_TAB.UNPAID ? 'solid' : 'outline'"
                :color="selectedTab === INVOICE_TAB.UNPAID ? 'primary' : 'neutral'"
                @click="selectedTab = INVOICE_TAB.UNPAID"
            >
                Ubetalte
            </UButton>
            <UButton
                size="sm"
                :variant="selectedTab === INVOICE_TAB.DEBT_COLLECTION ? 'solid' : 'outline'"
                :color="selectedTab === INVOICE_TAB.DEBT_COLLECTION ? 'primary' : 'neutral'"
                @click="selectedTab = INVOICE_TAB.DEBT_COLLECTION"
            >
                Inkasso
            </UButton>
        </UFieldGroup>
    </div>
</template>

<script setup lang="ts">

import {INVOICE_TAB} from '@/invoice/types/InvoiceTab'
import emitter from '@/services/infrastructure/emitter'
import {SHOW_INVOICE_LISTS} from '@/types/invoice/InvoiceEvent'
import {ref} from 'vue'
import {InvoiceDraftList} from '@/invoice/feature-toggles'

const selectedTab = defineModel<INVOICE_TAB>('selectedTab')
const showInvoiceLists = ref(false)

const toggleInvoiceLists = () => {
    showInvoiceLists.value = !showInvoiceLists.value
    emitter.emit(SHOW_INVOICE_LISTS, showInvoiceLists.value)
}

</script>

<style scoped>

</style>